module.exports = __webpack_public_path__ + "img/BonnieofDex.d6937849.png";